import { Component } from '@angular/core';
import { SinglePlanPromoPriceComponent, TitlePriceVariant } from '@basket';
import {
  ButtonComponent,
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  IconComponent,
  ProgressionStepsComponent,
  TermsAndConditionsPanelComponent,
  TrustboxComponent,
} from '@components';
import { translation as dataAccessTranslation } from '@data-access';
import {
  CurrencyFormatPipe,
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@i18n';
import { translation } from '../../i18n/translation.constant';
import { SinglePlanSaleBaseComponent } from '../single-plan-sale/single-plan-sale.base';

@Component({
  selector: 'app-single-plan-sale-b',
  imports: [
    ButtonComponent,
    CurrencyFormatPipe,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    IconComponent,
    ProgressionStepsComponent,
    SinglePlanPromoPriceComponent,
    TermsAndConditionsPanelComponent,
    TranslatePipe,
    TrustboxComponent,
  ],
  templateUrl: './single-plan-sale-b.component.html',
  styleUrl: './single-plan-sale-b.component.scss',
  providers: [
    provideTranslationDictionaryMapping(translation),
    provideTranslationDictionaryMapping(dataAccessTranslation),
  ],
})
export class SinglePlanSaleBComponent extends SinglePlanSaleBaseComponent {
  protected readonly featureFlagVariant = 'test' as const;

  protected readonly TitlePriceVariant = TitlePriceVariant;
}
